// extracted by mini-css-extract-plugin
export default {"main":"minecraftServerCard_main__HXaN3"};